export default {
    planning: null,
    userDispos: [],
    isLoading: false,
    error: null
}